import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

  import Dropdown from '@/components/common/Dropdown.vue'
  import Choice from '@/components/common/Choice.vue'
  import PhoneNumberInput from '@/components/common/PhoneNumberInput.vue'
  import ExpandableTextAreaInput from '@/components/common/ExpandableTextAreaInput.vue'

  import useIcons from '@/composables/useIcons'

  import type { PropType } from 'vue'
  import type { ProfileQuestionAnswer, StructuredCompanyProfileQuestion } from '@/services/interfaces/Auth0'
  import type { DropdownItem, SvgRendererProps } from '@/services/interfaces/Common'
  import type { QuestionAnswer } from '@/services/interfaces/QuizQuestion'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileQuestion',
  props: {
    question: {
      type: Object as PropType<StructuredCompanyProfileQuestion>,
      required: true,
    },
    selectedAnswers: {
      type: Array as PropType<QuestionAnswer[]>,
      required: true,
    },
    onAnswerChoiceClick: {
      type: Function as PropType<
        (selectedAnswers: QuestionAnswer[], choiceId: string, questionId: string, type?: string) => void
      >,
      required: true,
    },
    setAnswer: {
      type: Function as PropType<(questionId: string, text: string, answerType: 'phone' | 'text') => void>,
      required: true,
    },
    showErrorText: {
      type: Boolean,
      default: false,
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    questionTextAnswer: {
      type: String,
      default: '',
    },
  },
  setup(__props) {

const props = __props;

  const { checkboxSquareChecked, checkboxSquare } = useIcons()

  

  const dropdownChoices = computed(() => {
    return (answers: ProfileQuestionAnswer[]): DropdownItem[] => {
      return answers.map((answer) => ({
        type: answer.id,
        title: answer.answer,
        selectable: true,
      }))
    }
  })

  const checkSelectedChoices = computed(() => (questionId: string, answerId: string) => {
    if (!props.selectedAnswers.length) return false
    return props.selectedAnswers.some((q) => q.questionId === questionId && q.selectedAnswerIds.includes(answerId))
  })

  const selectedChoice = computed(() => (questionId: string, choiceId: string): SvgRendererProps => {
    return checkSelectedChoices.value(questionId, choiceId)
      ? { icon: checkboxSquareChecked.value, strokeColor: 'var(--primary-text-color)' }
      : { icon: checkboxSquare.value, strokeColor: 'var(--primary-text-color)' }
  })

  const selectedDropdownChoice = computed(
    () => (questionId: string) =>
      props.selectedAnswers?.find((a) => a.questionId === questionId)?.selectedAnswerIds[0] ?? '',
  )

return { __sfc: true,checkboxSquareChecked, checkboxSquare, props, dropdownChoices, checkSelectedChoices, selectedChoice, selectedDropdownChoice, computed, Dropdown, Choice, PhoneNumberInput, ExpandableTextAreaInput, useIcons }
}

})